import { request } from '@/_service/http-client';
import type { IResponse } from '../types';

export interface GetCategoryWithProductsParams {
  shipper_id?: string;
  menu_id?: string;
  page?: number;
  limit?: number;
  is_active?: boolean;
  has_product?: boolean;
  delivery_type?: string;
  fields?: string;
  tag_ids?: string;
  sort?: string;
  platform_id?: string;
}

function cleanQueryParams(
  params: Omit<GetCategoryWithProductsParams, 'shipper_id' | 'platform_id'>,
) {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  );
}

export const getCategoryWithProducts = async (
  params?: GetCategoryWithProductsParams,
): Promise<IResponse> => {
  const { shipper_id, platform_id, ...rawParams } = params || {};
  const qparams = cleanQueryParams(rawParams);
  const headers: Record<string, string> = {};

  if (shipper_id) {
    headers.Shipper = shipper_id;
  }
  if (platform_id) {
    headers.Platform = platform_id;
  }

  const response = await request.get<IResponse>('/v3/category-with-products', {
    params: qparams,
    headers,
  });

  return response.data;
};
